module.exports = __webpack_public_path__ + "img/alex7.9a6911b5.png";